import { mapTaskStatusToText } from '../../../../constants';
import styles from './PatientTask.module.scss';
import cx from 'classnames';
import { Icon, Text } from 'components';
import { Icons } from 'components/Icon/Icon';
import { TreatmentPlanTask } from 'types';

type Props = {
  task: TreatmentPlanTask | 'BLOCKED' | 'ARCHIVED';
};

const taskIcon = {
  DIAGNOSIS_TO_DO: 'Diagnosis',
  DIAGNOSIS_SUBMITTED: 'Diagnosis',
  LETTER_TO_DO: 'Letter',
  LETTER_SUBMITTED: 'Letter',
  LETTER_SENT: 'Letter',
  IN_TREATMENT: 'Tooth',
  TREATMENT_PRE_FINISH: 'Finished',
  TREATMENT_POST_FINISH: 'Finished',
  COMPLETED: 'Finished',
  BLOCKED: 'OutOfTreatment',
  ARCHIVED: 'Archive',
};

export const PatientTask = ({ task }: Props) => {
  return (
    <div className={cx(styles.chip, styles[task.toLowerCase()])}>
      {task !== TreatmentPlanTask.TO_SUBMIT ? <Icon name={taskIcon[task] as Icons} className={styles.icon} /> : null}
      <Text type="overline">{mapTaskStatusToText[task]}</Text>
    </div>
  );
};
